import { createContext, useContext } from 'react'

const TeamSpiritTableContext = createContext(null)

export const TeamSpiritTableProvider = ({ value, children }) => (
  <TeamSpiritTableContext.Provider value={value}>
    {children}
  </TeamSpiritTableContext.Provider>
)

export const useTeamSpiritTable = () => {
  const context = useContext(TeamSpiritTableContext)
  if (!context) {
    throw new Error('useTeamSpiritTable must be used inside TeamSpiritTableProvider')
  }
  return context
}
